import posthog, { type PostHog, type PostHogConfig } from 'posthog-js';
import {
  createContext,
  type PropsWithChildren,
  useContext,
  useEffect,
  useState,
} from 'react';

const PostHogContext = createContext<PostHog | null>(null);

interface PostHogProviderProps {
  options?: Partial<PostHogConfig>;
  apiKey?: string;
}

export function PostHogProvider({
  children,
  options,
  apiKey,
}: PropsWithChildren<PostHogProviderProps>) {
  const [posthogInstance, setPosthogInstance] = useState<PostHog | null>(null);

  useEffect(() => {
    if (apiKey && !posthogInstance) {
      setPosthogInstance(posthog.init(apiKey, options));
    }
  }, [apiKey, options, posthogInstance]);

  return (
    <PostHogContext.Provider value={posthogInstance}>
      {children}
    </PostHogContext.Provider>
  );
}

export function usePostHog() {
  return useContext(PostHogContext);
}
